import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { whatsappNumber, whatsappMessage } from '../../data/mock';

const CTA = () => {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section className="py-20 lg:py-28 px-4" style={{ background: 'var(--bg-section-alt)' }}>
      <div className="container mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative rounded-3xl overflow-hidden"
          style={{ background: 'var(--brand-gradient)' }}
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
          
          <div className="relative z-10 p-8 lg:p-16 text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="inline-flex items-center gap-2 bg-white/20 rounded-full px-4 py-2 mb-6"
            >
              <MessageCircle className="w-5 h-5 text-white" />
              <span className="text-white font-medium">Comece agora mesmo</span>
            </motion.div>

            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6 max-w-3xl mx-auto leading-tight">
              Pronto para automatizar o atendimento do seu consultório?
            </h2>
            
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Junte-se a outros médicos que já automatizaram seu atendimento e têm mais tempo para o que realmente importa, o seu paciente.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp inline-flex items-center justify-center gap-2 px-8 py-4"
              >
                Quero automatizar meu atendimento
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>

            <p className="text-white/70 text-sm mt-6">
              Atendimento personalizado • Configuração rápida • Suporte dedicado
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
